@if (userStateService.user()) {
  <div class="h-[calc(100%_-_var(--header-height))]">
    <router-outlet />
  </div>
} @else {
  <div class="h-full w-full flex items-center justify-center">
    <router-outlet />
  </div>
}
